export default (id) => {
    const what = String(id);

    return ({ _id }) => String(_id) === what;
};
